import React from "react";
import SVG from "react-inlinesvg";
import Trans from "tsi-common-react/src/common/Trans";
import { t } from "ttag";

import iconTempurMeMattress from "../../svg/tempur-me-mattress.svg";

interface IProps {}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to simple render-only logic with no state or lifecycle methods.
export class TempurMeFooterSignup extends React.Component<IProps, IState> {
    render() {
        return (
            // TODO(i18n): URL should be internationalized or configurable per locale
            <a
                href="http://register.tempurpedic.com/tempurme"
                target="_blank"
                className="footer-offers__header site-footer__header"
                rel="noreferrer"
            >
                <Trans
                    fmtString={t`Join <Underline>TEMPUR-ME</Underline> <PromoIcon></PromoIcon> and get $300 in FREE Accessories`}
                    data={{
                        Underline: (content) => (
                            <span
                                key="1"
                                className="site-footer__header--underline"
                            >
                                {content}
                            </span>
                        ),
                        PromoIcon: () => (
                            <SVG
                                key="2"
                                className="footer-offers__header-icon"
                                src={iconTempurMeMattress}
                                title={t`Mattress Icon`}
                            />
                        ),
                    }}
                />
            </a>
        );
    }
}
